import React from 'react';
import { Lightning } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

export default function TokenMessagingBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full bg-gradient-to-r from-cyan-500/20 via-purple-500/20 to-cyan-500/20 border-y border-cyan-500/30 py-4 px-6"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center">
        <Lightning size={24} weight="fill" className="text-cyan-400 animate-pulse" />
        <p className="text-white text-lg font-semibold">
          One token ($5) = one consultation with any mind.{' '}
          <a 
            href="https://keywebster.gumroad.com/l/mimet" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-cyan-400 underline hover:text-cyan-300 transition font-bold"
          >
            Buy now →
          </a>
        </p>
        <Lightning size={24} weight="fill" className="text-cyan-400 animate-pulse" />
      </div>
    </motion.div>
  );
}
